import type { AnyAction } from "redux";
import type { ThunkAction } from "redux-thunk";
import * as actionTypes from "./actionTypes";
import type { CartItem, CartOrderDetails, CartState } from "../../types/orders";

export type CartAction =
  | { type: typeof actionTypes.SET_CART; cart: CartItem[] }
  | { type: typeof actionTypes.SET_ORDER_DETAILS; orderDetails: CartOrderDetails | null };

type CartThunk = ThunkAction<void, { cart: CartState }, unknown, AnyAction>;

function readStoredValue<T>(key: string, fallback: T): T {
  const stored = localStorage.getItem(key);
  if (!stored) return fallback;
  try {
    return JSON.parse(stored) as T;
  } catch {
    return fallback;
  }
}

function readStoredCart(): CartItem[] {
  const storedCart = readStoredValue<unknown>("cart", []);
  return Array.isArray(storedCart) ? (storedCart as CartItem[]) : [];
}

export const dispatchCart = (cart: CartItem[]): CartAction => {
  const normalizedCart = Array.isArray(cart) ? cart : [];
  localStorage.setItem("cart", JSON.stringify(normalizedCart));
  return { type: actionTypes.SET_CART, cart: normalizedCart };
};

export const dispatchOrderDetails = (orderDetails: CartOrderDetails | null): CartAction => {
  localStorage.setItem("orderDetails", JSON.stringify(orderDetails));
  return { type: actionTypes.SET_ORDER_DETAILS, orderDetails };
};

export const setCart = (cart: CartItem[]): CartThunk => (dispatch) => {
  dispatch(dispatchCart(cart));
};

export const modifyCart = (item: CartItem): CartThunk => (dispatch) => {
  const cartCopy = [...readStoredCart()];
  const itemIndex = cartCopy.findIndex((element) => element.id === item.id);
  if (itemIndex >= 0) {
    if (item.quantity === 0) cartCopy.splice(itemIndex, 1);
    else cartCopy[itemIndex] = item;
  } else {
    cartCopy.push(item);
  }
  dispatch(dispatchCart(cartCopy));
};

export const autchCheckCart = (): CartThunk => (dispatch) => {
  dispatch(dispatchCart(readStoredCart()));
};

export const authCheckOrderDetails = (): CartThunk => (dispatch) => {
  dispatch(dispatchOrderDetails(readStoredValue<CartOrderDetails | null>("orderDetails", null)));
};

export const setOrderDetails = (orderDetails: CartOrderDetails | null): CartThunk => (dispatch) => {
  dispatch(dispatchOrderDetails(orderDetails));
};
